<h2>利用規約と個人情報の取り扱い</h2>
<p>
  内容の改定が行われました。サービスをご利用いただくには、最新の<a
    [href]="privacyPolicy.url.toString()"
    target="blank"
    >利用規約</a
  >と<a [href]="termsOfService.url.toString()" target="blank"
    >個人情報の取り扱い</a
  >に同意する必要があります。
</p>

<div>
  <span (click)="agreement()">同意する</span>
</div>
